import React from 'react';
import bgImage from '../assets/images/dbqbg.png';

const Hero = () => {
    return (
        <section id="home" className="relative min-h-[500px] md:h-[650px] flex items-center justify-center overflow-hidden">
            {/* Background Overlay with dark blue tint */}
            <div className="absolute inset-0 bg-[#0a1d37]/85 z-10" />

            {/* Background Image */}
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${bgImage})` }}
            />

            <div className="container mx-auto px-6 md:px-12 relative z-20 text-white text-center py-20 md:py-0">
                <div className="max-w-4xl mx-auto">
                    <h4 className="text-xl md:text-3xl font-serif italic mb-2 text-white font-thin">Welcome to</h4>
                    <h1 className="text-3xl md:text-6xl font-normal mb-8 md:mb-12 tracking-[0.1em] md:tracking-[0.2em] uppercase" style={{ color: '#c9a770' }}>
                        DBQ TECHNOLOGIES
                    </h1>

                    <div className="mb-8 md:mb-12">
                        <h2 className="text-3xl md:text-5xl font-light leading-tight">
                            Our <span className="font-bold">Passion</span>
                        </h2>
                        <h2 className="text-3xl md:text-5xl font-light leading-tight">
                            for a Better <span className="font-bold">World!</span>
                        </h2>
                    </div>

                    <div className="max-w-4xl mx-auto px-2 md:px-4 text-center">
                        <p className="text-sm md:text-lg leading-relaxed text-white opacity-80 italic font-light">
                            DBQ Technologies developing innovative products to help businesses find solutions is what we do best.
                            Enablement of next-generation services is our forte, they include a vast majority of communication and information solutions that aid in business fulfillment.
                            <a href="#services" className="text-[#3b82f6] ml-2 not-italic hover:underline block md:inline-block mt-2 md:mt-0">Learn More</a>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
